import { Box, Button, Container, Typography } from "@mui/material";
import {
  Person,
  Mail,
  DialpadSharp,
  Password,
  Lock,
} from "@mui/icons-material";
import AuthInput from "./AuthInput";
import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import axios from "axios";
import { host } from "../constant/backendpath";
import { useLoader } from "../context/LoaderContext";
import Alert from "../widgets/AlertModal";
import logo from "../assets/img/logo2.svg";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{6,}$/;
const otpRegex = /^\d{6}$/;

const Auth = ({ setCurrent, setIsLogged }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passWord, setPassWord] = useState("");
  const [errors, setErrors] = useState({});
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [passwordVisibility2, setPasswordVisibility2] = useState(false);
  const isMobile = useMediaQuery("(max-width:733px)");
  const { loading, setLoading } = useLoader();
  const [sent, setSent] = useState(false);
  const [otpSecondsLeft, setOtpSecondsLeft] = useState(0);
  const [open, setOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertOnOk, setAlertOnOk] = useState(() => () => {});
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${host}login`, { withCredentials: true });
        if (res.status === 200) {
          setIsLogged(true);
          setCurrent(0);
        }
      } catch {
        // console.log("user not found");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const togglePasswordVisibility = () => setPasswordVisibility((prev) => !prev);
  const togglePasswordVisibility2 = () =>
    setPasswordVisibility2((prev) => !prev);

  useEffect(() => {
    if (!otpSecondsLeft) return;
    const timer = setTimeout(() => {
      setOtpSecondsLeft((prev) => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpSecondsLeft]);

  useEffect(() => {
    if (otpSecondsLeft === 0) {
      setSent(false);
    }
  }, [otpSecondsLeft]);

  const validateRegister = () => {
    const newErrors = {};
    if (!emailRegex.test(email)) newErrors.email = true;
    if (!otpRegex.test(otp)) newErrors.otp = true;
    if (!passwordRegex.test(password)) newErrors.password = true;
    if (password !== confirmPassword) newErrors.confirmPassword = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateLogin = () => {
    const newErrors = {};
    if (!emailRegex.test(userName)) newErrors.userName = true;
    if (passWord.length < 6) newErrors.passWord = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateLogin()) {
      setAlertMessage("All field are required!!");
      setAlertType("warning");
      setOpen(true);
      return;
    }
    try {
      const res = await axios.post(
        `${host}login`,
        { email: userName, password: passWord },
        { withCredentials: true },
      );
      if (res.status === 200) {
        setAlertMessage("Login Successful");
        setAlertType("success");
        setOpen(true);
        setIsLogged(true);
        setAlertOnOk(() => () => {
          setCurrent(0);
        });
      }
    } catch {
      setAlertMessage("User Not Found");
      setAlertType("error");
      setOpen(true);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!validateRegister()) {
      if (!passwordRegex.test(password)) {
        setAlertMessage(
          `Use a strong password: \n
          at least 6 characters with uppercase, lowercase, and a special symbol.`
        );
        setAlertType("warning");
        setOpen(true);
      } else if (password !== confirmPassword) {
        setAlertMessage("Passwords do not match");
        setAlertType("error");
        setOpen(true);
      } else {
        setAlertMessage("Please fix the highlighted fields.");
        setAlertType("warning");
        setOpen(true);
      }
      return;
    }

    try {
      const res = await axios.post(
        `${host}register`,
        { email, password, otp },
        { headers: { "Content-Type": "application/json" } },
      );
      if (res.status === 200) {
        setAlertMessage("Registered successfully!");
        setAlertType("success");
        setOpen(true);
        setIsLogin(true);
      }
    } catch {
      setAlertMessage("Registration Failed");
      setAlertType("error");
      setOpen(true);
    }
  };

  const sendotp = async () => {
    try {
      setSent(true);
      const res = await axios.post(`${host}otpSend`, {
        toemail: email,
        type: "register",
      });
      if (res.status === 200) {
        setOtpSent(true);
        setOtpSecondsLeft(120);
        setAlertMessage("OTP Sent Successfully");
        setAlertType("info");
        setOpen(true);
      }
    } catch (error) {
      setAlertMessage(error.response?.data?.msg || "Failed to send OTP");
      setAlertType("error");
      setOpen(true);
      setSent(false);
      setOtpSecondsLeft(0);
    }
  };

  return !loading ? (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          // width: "100%",
          background:
            "linear-gradient(180deg, #f5f8ff 0%, #eaf4ff 55%, #ffffff 100%)",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1.5, sm: 2, md: 4 },
          py: { xs: 3, md: 6 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            mb: 3,
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Thiran Logo"
            sx={{ width: { xs: 56, sm: 72 }, height: { xs: 56, sm: 72 } }}
          />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              letterSpacing: "0.12em",
              color: "#0f4e99",
              fontSize: { xs: "1.3rem", sm: "1.5rem" },
            }}
          >
            THIRAN
          </Typography>
        </Box>
        <Container
          sx={{
            width: { xs: "100%", sm: "100%", md: "90%", lg: "520px" },
            maxWidth: "520px",
            p: { xs: 2.25, sm: 3, md: 4 },
            borderRadius: { xs: "24px", sm: "32px" },
            backgroundColor: "rgba(255,255,255,0.95)",
            boxShadow: "0 32px 80px rgba(37, 64, 97, 0.12)",
            border: "1px solid rgba(10, 88, 225, 0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Switch between Login and Register */}
          {isLogin ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  mb: 0.5,
                  color: "#0f4e99",
                  fontSize: { xs: "1.6rem", sm: "2.125rem" },
                }}
              >
                Welcome back
              </Typography>

              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "#5a6d89", mb: 3 }}
              >
                Sign in to continue to your Thiran dashboard.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  color: "#4c5f7f",
                  mb: 4,
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 0.5,
                }}
              >
                Don’t have an account?{" "}
                <Button
                  onClick={() => setIsLogin(false)}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#0f4e99",
                  }}
                >
                  Register
                </Button>
              </Typography>

              {/* Login Inputs */}
              <AuthInput
                label="Email"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                icon={Person}
                isError={errors.userName}
                isValid={emailRegex.test(userName)}
              />
              <AuthInput
                label="Password"
                value={passWord}
                onChange={(e) => setPassWord(e.target.value)}
                icon={Lock}
                isPassword
                showPassword={passwordVisibility}
                togglePassword={togglePasswordVisibility}
                isError={errors.passWord}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                  mt: 4,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleLogin}
                  sx={{
                    width: "100%",
                    borderRadius: "18px",
                    textTransform: "none",
                    py: 1.5,
                    background:
                      "linear-gradient(90deg, #0366d6 0%, #0797F3 100%)",
                    boxShadow: "0 12px 24px rgba(3, 103, 214, 0.18)",
                  }}
                >
                  Login
                </Button>
                <Button
                  size="small"
                  onClick={() => setCurrent(7)}
                  sx={{ textTransform: "none", color: "#1f5bb5" }}
                >
                  Forgot Password?
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  mb: 0.5,
                  color: "#0f4e99",
                  fontSize: { xs: "1.6rem", sm: "2.125rem" },
                }}
              >
                Create your account
              </Typography>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "#5a6d89", mb: 3 }}
              >
                Join Thiran and start managing your projects with ease.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  color: "#4c5f7f",
                  mb: 3,
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 0.5,
                }}
              >
                Already have an account?{" "}
                <Button
                  onClick={() => setIsLogin(true)}
                  sx={{
                    textTransform: "none",
                    fontWeight: "700",
                    color: "#0f4e99",
                  }}
                >
                  Login
                </Button>
              </Typography>

              {/* Register Inputs */}
              <AuthInput
                label="Email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                icon={Mail}
                isError={errors.email}
                sendotp={sendotp}
                sent={sent}
                otpSecondsLeft={otpSecondsLeft}
                isValid={emailRegex.test(email)}
              />
              <AuthInput
                label="OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                icon={DialpadSharp}
                isError={errors.otp}
                isValid={otpRegex.test(otp)}
                disabled={!otpSent}
              />
              <AuthInput
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                icon={Password}
                isPassword
                showPassword={passwordVisibility}
                togglePassword={togglePasswordVisibility}
                isError={errors.password}
              />
              <AuthInput
                label="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                icon={Password}
                isPassword
                showPassword={passwordVisibility2}
                togglePassword={togglePasswordVisibility2}
                isError={errors.confirmPassword}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleRegister}
                  sx={{
                    width: "100%",
                    borderRadius: "18px",
                    textTransform: "none",
                    py: 1.5,
                    background:
                      "linear-gradient(90deg, #0366d6 0%, #0797F3 100%)",
                    boxShadow: "0 12px 24px rgba(3, 103, 214, 0.18)",
                  }}
                >
                  Register
                </Button>
              </Box>
            </Box>
          )}
        </Container>
      </Box>
      <Alert
        open={open}
        setOpen={setOpen}
        message={alertMessage}
        type={alertType}
        onOk={alertOnOk}
      />
    </>
  ) : null;
};

export default Auth;
